<template>
  <div
    @contextmenu.prevent="removeContextMenu"
    class="image-card"
    :class="[mainClass]"
    v-lazy:background-image="image"
  >
    <div class="image-card-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageCard",

  props: {
    contentClass: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    mainClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    removeContextMenu(e) {
      e.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
.image-card {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  background-color: $grey;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
